export default "__VITE_ASSET__D2JC4QVR__ 120w, __VITE_ASSET__BhYJB49W__ 240w, __VITE_ASSET__DdYWUIE7__ 480w, __VITE_ASSET__CS8fYMzW__ 512w";